// src/pages/public/_publicShared.jsx
// Helpers compartidos por pantallas públicas legales (Terms, Privacy).
// Pixel-perfect del mockup v4 (entregable_claude/screens_public.jsx líneas 3-20).
import React from 'react';

export const PubHead = ({ back, title }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 22 }}>
    <button
      onClick={back}
      style={{
        width: 36,
        height: 36,
        borderRadius: 10,
        background: 'var(--bg-elev)',
        border: '1px solid var(--line)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
        <path d="M15 6l-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
    <div style={{ fontWeight: 600, fontSize: 15 }}>{title}</div>
  </div>
);

export const LegalSection = ({ n, title, children }) => (
  <div style={{ marginBottom: 22 }}>
    <h3
      style={{
        fontFamily: 'var(--font-display)',
        fontSize: 16,
        fontWeight: 700,
        letterSpacing: '-0.01em',
        margin: 0,
        marginBottom: 8,
        display: 'flex',
        gap: 8,
      }}
    >
      <span style={{ color: 'var(--muted)', fontWeight: 500 }} className="num">
        {n}.
      </span>
      {title}
    </h3>
    <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>{children}</div>
  </div>
);
